export const ActionTypes = {
    SET_PANEL_MODE: 'AI_ASSISTANT/SET_PANEL_MODE',
    SET_CONTEXT: 'AI_ASSISTANT/SET_CONTEXT',

    // Conversations
    SET_CONVERSATIONS: 'AI_ASSISTANT/SET_CONVERSATIONS',
    APPEND_CONVERSATIONS: 'AI_ASSISTANT/APPEND_CONVERSATIONS',
    ADD_CONVERSATION: 'AI_ASSISTANT/ADD_CONVERSATION',
    PREPEND_CONVERSATION: 'AI_ASSISTANT/PREPEND_CONVERSATION',
    SET_ACTIVE_CONVERSATION: 'AI_ASSISTANT/SET_ACTIVE_CONVERSATION',
    UPDATE_CONVERSATION: 'AI_ASSISTANT/UPDATE_CONVERSATION',
    ADOPT_CONVERSATION: 'AI_ASSISTANT/ADOPT_CONVERSATION',

    // Messages
    SET_MESSAGES: 'AI_ASSISTANT/SET_MESSAGES',
    ADD_MESSAGE: 'AI_ASSISTANT/ADD_MESSAGE',
    REMOVE_MESSAGE: 'AI_ASSISTANT/REMOVE_MESSAGE',
    UPDATE_MESSAGE_ID: 'AI_ASSISTANT/UPDATE_MESSAGE_ID',
    APPEND_TOKEN: 'AI_ASSISTANT/APPEND_TOKEN',
    PREPEND_MESSAGES: 'AI_ASSISTANT/PREPEND_MESSAGES',
    SET_MESSAGE_PAGINATION: 'AI_ASSISTANT/SET_MESSAGE_PAGINATION',
    SET_MESSAGE_CITATIONS: 'AI_ASSISTANT/SET_MESSAGE_CITATIONS',
    SET_STREAMING: 'AI_ASSISTANT/SET_STREAMING',
    SET_LOADING_CONVERSATIONS: 'AI_ASSISTANT/SET_LOADING_CONVERSATIONS',
    SET_LOADING_CONVERSATION: 'AI_ASSISTANT/SET_LOADING_CONVERSATION',
    SET_LOADING_EARLIER_MESSAGES: 'AI_ASSISTANT/SET_LOADING_EARLIER_MESSAGES',
    SET_ERROR: 'AI_ASSISTANT/SET_ERROR',
    CLEAR_ERROR: 'AI_ASSISTANT/CLEAR_ERROR',

    // Escalation
    ESCALATE_CONVERSATION: 'AI_ASSISTANT/ESCALATE_CONVERSATION',

    // Deletion
    REMOVE_CONVERSATION: 'AI_ASSISTANT/REMOVE_CONVERSATION',

    // Reset entire state
    RESET: 'AI_ASSISTANT/RESET',
};
